const activityType = {
  course: 'Course',
  language: 'Languages',
  event: 'Event',
};

export default activityType;
